import { Divider, DividerProps } from "@mui/material";
import * as React from "react";

function TitleDivider(props: DividerProps) {
  return (
    <Divider
      {...props}
      sx={{
        width: 100,
        mx: "auto",
        mt: 1,
        mb: 2,
        borderColor: (t) => t.palette.secondary.light,
        borderBottomWidth: "medium",
        ...props.sx,
      }}
    />
  );
}

export { TitleDivider };
